import { Stack, Typography } from '@mui/joy';
import { memo } from 'react';
import { FcExpired } from 'react-icons/fc';

const ExpiredToken = memo(() => {
  return (
    <Stack justifyContent="center" alignItems="center" flexGrow={1} rowGap={5}>
      <FcExpired size={140} />
      <Stack sx={{ textAlign: 'center', px: '16px' }} spacing={'8px'}>
        <Typography level="body-md" fontWeight={600}>
          기한이 만료되었습니다.
        </Typography>
        <Typography level="body-md" fontWeight={600}>
          다시 요청해주세요.
        </Typography>
      </Stack>
    </Stack>
  );
});

ExpiredToken.displayName = 'ExpiredToken';

export { ExpiredToken };

